// extracted by mini-css-extract-plugin
export default {"container":"SectionHeader_container__gNr9p"};